module.exports = __webpack_public_path__ + "img/sam.e81a7ac4.png";